// extracted by mini-css-extract-plugin
export default {"page":"Home_page__kfnCK"};